<ftr-page>
  @if (errorMessage) {
    <article>
      <ftr-notification [type]="notificationType.Error">
        <div>{{ errorMessage }}</div>
      </ftr-notification>
    </article>
  }
</ftr-page>
